

import Cookies  from 'js-cookie';



function getCookieValueFunction(cookieName: string) : string{
    const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');

    if (name === cookieName) {
      return decodeURIComponent(value);
    }
  }

  return "";
}

function setCookieFunction(cookieName: string, cookieValue: string, expirationDateTime: Date){
  Cookies.set(cookieName, cookieValue, {
    expires: expirationDateTime
});

}


function formatDateFunction(date: Date  | string | undefined): string{
  if (!date) return '';

  let dateObj: Date;
    
  if (typeof date === 'string') {
      // Truncate the microseconds if present
      date = date.split('.')[0];
      dateObj = new Date(date);

      // Check if the date is valid
      if (isNaN(dateObj.getTime())) {
          return ''; // Invalid date
      }
  } else {
      dateObj = date;
  }

  const month = (dateObj.getMonth() + 1).toString();
  const day = dateObj.getDate().toString().padStart(2, '0');
  const year = dateObj.getFullYear().toString();
  
  return `${month}/${day}/${year}`;
}


function formatLongDateFunction(date: Date | string | undefined): string {
  if (!date) return '';

  let dateObj: Date;
  
  if (typeof date === 'string') {
      // Truncate the microseconds if present
      date = date.split('.')[0];
      dateObj = new Date(date);

      // Check if the date is valid
      if (isNaN(dateObj.getTime())) {
          return ''; // Invalid date
      }
  } else {
      dateObj = date;
  }

  const months = [
      'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
  ];
  
  const monthName = months[dateObj.getMonth()];
  const day = dateObj.getDate().toString();
  const year = dateObj.getFullYear().toString();

  return `${monthName} ${day}, ${year}`;
}


function isEmailValidFunction(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

function getPermissionFunction(){
  const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');

    if (name === "permission") {
      return decodeURIComponent(value);
    }
  }

  return "";
}


function formatNumberFunction(value: number): string {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
}

const index = {
    getCookieValue: getCookieValueFunction,
    setCookie: setCookieFunction,
    formatDate: formatDateFunction,
    isEmailValid: isEmailValidFunction,
    getPermission: getPermissionFunction,
    formatLongDate: formatLongDateFunction,
    formatNumber : formatNumberFunction
}

export default index;